import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const createPartnerCompany = async ({ name, email }) => {
  const {
    data: partnerCompany
  } = await axios.post(`${API_URL}/partner-companies`, {
    name,
    email
  });

  return { partnerCompany };
}

const updatePartnerCompany = async ({ partnerCompanyId, updateData }) => {
  const {
    data: partnerCompany
  } = await axios.put(`${API_URL}/partner-companies/${partnerCompanyId}`, updateData);

  return { partnerCompany };
}

const inviteAdmin = async ({ partnerCompanyId, fullName, email }) => {
  const {
    data: { partnerCompany, admin }
  } = await axios.put(`${API_URL}/partner-companies/${partnerCompanyId}/invite-admin`, {
    fullName,
    email
  });

  return { partnerCompany, admin };
}

const removeAdmin = async (partnerCompanyId) => {
  await axios.delete(`${API_URL}/partner-companies/${partnerCompanyId}/remove-admin`);

  return;
}

const inviteStaff = async ({ partnerCompanyId, fullName, email }) => {
  const {
    data: { partnerCompany, staff }
  } = await axios.put(`${API_URL}/partner-companies/${partnerCompanyId}/invite-staff`, {
    fullName,
    email
  });

  return { partnerCompany, staff };
}

const removeStaff = async ({ partnerCompanyId, staffId }) => {
  const url = `${API_URL}/partner-companies/${partnerCompanyId}/staff/${staffId}`;

  await axios.delete(url);

  return;
}

const partnerCompanyService = {
  createPartnerCompany,
  updatePartnerCompany,
  inviteAdmin,
  removeAdmin,
  inviteStaff,
  removeStaff
};

export default partnerCompanyService;
